module.exports = __webpack_public_path__ + "img/Flag_of_Macau.06a8169c.svg";